import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAudio } from "@/contexts/AudioContext";
import { debugLog } from "@/utils/debugLogger";

/**
 * AudioRouteCleanup component that stops all audio players when the route changes
 * This ensures that audio doesn't continue playing when users navigate to a new page
 * Enhanced with better logging and coordination with TTS cache
 */
export function AudioRouteCleanup() {
  const { pathname } = useLocation();
  const { stopAllAudio, isAudioPlaying, getActiveAudioIds } = useAudio();

  useEffect(() => {
    // Check if there's audio playing before route change
    const wasPlayingAudio = isAudioPlaying();
    const activeAudioIds = getActiveAudioIds();
    
    if (wasPlayingAudio) {
      debugLog('audio', `Route changing to: ${pathname} - ${activeAudioIds.length} audio player(s) currently active`, { activeIds: activeAudioIds }, 'AudioRouteCleanup');
    } else {
      debugLog('audio', `Route changed to: ${pathname} - No active audio to stop`, undefined, 'AudioRouteCleanup');
    }

    // Add a small delay to allow components to stabilize after route change
    const timeoutId = setTimeout(() => {
      if (wasPlayingAudio) {
        debugLog('audio', `Executing delayed audio stop for route: ${pathname}`, undefined, 'AudioRouteCleanup');
      }
      stopAllAudio();
    }, 100); // 100ms delay to prevent premature stopping

    return () => {
      clearTimeout(timeoutId);
    };
  }, [pathname, stopAllAudio, isAudioPlaying, getActiveAudioIds]);

  // This component doesn't render anything
  return null;
}